import React from "react";
import Plus from "../../assets/svgs/Plus";
import Table from "../components/EmployeeView/Table.jsx";
import Header from "../components/Header";

const EmployeeView = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <h2 className="text-lg mb-2">Employee</h2>
      <div className="w-full flex justify-end">
        <button className="flex space-x-2 items-center px-4 py-1.5 text-base bg-pink-600 text-white shadow rounded focus:ring">
          <span>Filter</span>
          <span className="w-4 h-4 flex items-center justify-center rounded-full shadow bg-pink-500">
            <Plus />
          </span>
        </button>
      </div>
      <Table />
    </div>
  );
};

export default EmployeeView;
